// Components==============
import { faArrowLeft, faBars } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Shade from 'components/UI/Shade';
import { motion } from 'framer-motion';
import React, { useState } from 'react';
import NavButton from '../NavButton';
import NavItems from '../NavItems';
import './index.module.scss';
// =========================

export default function MobileMenu() {
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    return (
        <div>
            <motion.div
                whileHover={{ scale: 0.95 }}
                styleName="button"
                onClick={() => setMenuIsOpen(true)}
            >
                <FontAwesomeIcon icon={faBars} />
            </motion.div>
            {menuIsOpen && (
                <>
                    <motion.div
                        animate={{ x: 0 }}
                        initial={{ x: -300 }}
                        transition={{ damping: 5 }}
                        styleName="sideMenu"
                    >
                        <button
                            onClick={() => setMenuIsOpen(false)}
                            type="button"
                            styleName="back area1"
                        >
                            <FontAwesomeIcon icon={faArrowLeft} />
                        </button>
                        {/* <div styleName="area2">
                            <NavButton />
                        </div> */}
                        <div styleName="area3">
                            <NavItems />
                        </div>
                    </motion.div>
                    <Shade onClick={() => setMenuIsOpen(false)} />
                </>
            )}
        </div>
    );
}
